import React from 'react';

export default function Component(props) {

  const { handleDMGRadio, showRadioMatrix, TranslateQuestion, question, questionindex, answersList, surveyLanguageCode,
    handleRadio, clicked, surveyScreenData, isMobile, rowData, isRowComplete } = props;



  let rowList = []
  if (question && question.dmgModule && question.dmgModule === "SELF") {
    rowList = rowData && rowData.selfList && rowData.selfList.length > 0 ? rowData.selfList : []
  } else if (question && question.dmgModule && question.dmgModule === "CROSS") {
    rowList = rowData && rowData.crossList && rowData.crossList.length > 0 ? rowData.crossList : []
  }


  function showNotCompletedFn() { return false };


  function getCheckFn(list, quesId, optAns, dmgValue) {
    let check = false;
    if (list && list.length > 0) {
      let getIndex = list.findIndex(prev => prev.questionId.toString() === quesId.toString());
      if (getIndex !== -1) {
        if (list && list[getIndex] && list[getIndex]["multiAnswer"] && list[getIndex]["multiAnswer"].length > 0) {
          console.log("multiAnswer---------->", list[getIndex]["multiAnswer"])
          let getIndex2 = list[getIndex]["multiAnswer"].findIndex(prev => prev.optionHead.toString() === dmgValue.toString());
          if (getIndex2 !== -1 && (list[getIndex]["multiAnswer"][getIndex2]["optionAns"].toString() === optAns.toString())) {
            check = true;
          }
        }

      }
    }
    return check
  }


  let rowListV1 = [];
  if (rowList && rowList.length > 0) {
    let substringToFind = 'Self';
    let sortOrder = rowList.filter(item => item.value.includes(substringToFind));
    console.log("rowList--x-->", rowList);

    rowList.forEach((ele, index) => {
      if (ele.value === (sortOrder && sortOrder[0] && sortOrder[0]["value"] ? sortOrder[0]["value"] : "")) {
        rowListV1.push({
          "name": ele.name,
          "value": ele.value,
          "index": 1
        })
      } else {
        rowListV1.push({
          "name": ele.name,
          "value": ele.value,
          "index": index + 1000
        })
      }
    });

    rowListV1.sort((a, b) => {
      return a.index - b.index;
    });


  }

  return (
    <>

      <div className="w-full mb-4 pt-2">

        <div className="  w-full " >

          {question && question.optionsList && question.optionsList.length > 0 && rowListV1 && rowListV1.length > 0 ?
            <div>
              <div className=" lg:block hidden overflow-y-auto h-[calc(100vh-16rem)]  " >
                <table className="w-full  "
                //  style={{ background: (surveyScreenData && surveyScreenData.OptionColor1) ? surveyScreenData.OptionColor1 : '#fff' }}
                >
                  <thead className="sticky top-0 z-10 bg-white">
                    <tr>
                      <td className="w-82 text-left py-1 px-4 text-sm   whitespace-pre-line"
                        style={{ color: showNotCompletedFn() ? '#e31919' : ((surveyScreenData && surveyScreenData.OptionColor2) ? surveyScreenData.OptionColor2 : 'black') }}
                      >

                      </td>

                      {question && question.optionsList && question.optionsList.length > 0 ?
                        question.optionsList.map((option, optionindex) =>
                          <td key={optionindex}
                            style={{
                              // color: (surveyScreenData && surveyScreenData.OptionColor2) ? surveyScreenData.OptionColor2 : '#212121',
                              // background: (surveyScreenData && surveyScreenData.OptionColor1) ? surveyScreenData.OptionColor1 : '#fff',
                            }}
                            className="py-1 px-2 font-semibold text-sm text-center  text-[#212121] break-words ">{
                              (surveyLanguageCode !== '') ?
                                (question && question.transl && question.transl[surveyLanguageCode] && question.transl[surveyLanguageCode].optionsList && question.transl[surveyLanguageCode].optionsList[option.id]) ?
                                  question.transl[surveyLanguageCode].optionsList[option.id] : option.name

                                : option.name
                            }</td>
                        ) : null}
                    </tr>

                  </thead>
                  <tbody className="">
                    {rowListV1 && rowListV1.length > 0 ?
                      rowListV1.map((row, index) =>
                        <tr key={index}>

                          <td className={"w-82  py-1 px-4 text-sm text-right whitespace-pre-line " + (isRowComplete(answersList, row.value, question) ? "text-[#212121]" : "text-red-500")}
                          // style={{ color: showNotCompletedFn(row) ? '#e31919' : ((surveyScreenData && surveyScreenData.OptionColor2) ? surveyScreenData.OptionColor2 : 'black') }}
                          >
                            {row.value}

                          </td>

                          {question && question.optionsList && question.optionsList.length > 0 ?
                            question.optionsList.map((option, optionindex) =>
                              <td key={optionindex}
                                className="text-center py-1 px-1 ">

                                {getCheckFn(answersList, question.id, option.name, row.value) ?
                                  <div onClick={() => handleDMGRadio(question, row, option)} className='bg-[#2196f3] rounded-md py-2 flex items-center justify-center text-white h-12 cursor-pointer'>
                                    <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="icon icon-tabler icons-tabler-outline icon-tabler-check"><path stroke="none" d="M0 0h24v24H0z" fill="none" /><path d="M5 12l5 5l10 -10" /></svg>
                                    {/* <span style={{ color: '#0ec934' }}
                                          className="material-icons">task_alt</span> */}
                                  </div>
                                  :
                                  <div onClick={() => handleDMGRadio(question, row, option)} className='bg-[#2196f3]/10 rounded-md py-2 h-12 cursor-pointer flex items-center justify-center text-[#2196f3]/50'>
                                    <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="icon icon-tabler icons-tabler-outline icon-tabler-circle"><path stroke="none" d="M0 0h24v24H0z" fill="none" /><path d="M12 12m-9 0a9 9 0 1 0 18 0a9 9 0 1 0 -18 0" /></svg>
                                  </div>
                                }

                              </td>
                            ) : null}
                        </tr>
                      ) : null}
                  </tbody>
                </table>
                <div className='h-10' />
              </div>

              {/* mobile */}
              <div className="overflow-y-auto lg:hidden block space-y-6" id="chatbot" >

                {rowListV1 && rowListV1.length > 0 ?
                  rowListV1.map((row, index) =>
                    <div key={index}>
                      <p className={"w-full  pb-2 px-0 text-base  whitespace-pre-line  font-semibold " + (isRowComplete(answersList, row.value, question) ? "text-[#212121]" : "text-red-500")}>
                        {row.value}
                      </p>

                      <div className='flex flex-wrap gap-2'>
                        {question && question.optionsList && question.optionsList.length > 0 ?
                          question.optionsList.map((option, optionindex) =>
                            <div key={optionindex}
                              className=" text-sm ">
                              {getCheckFn(answersList, question.id, option.name, row.value) ?
                                <div onClick={() => handleDMGRadio(question, row, option)} className='bg-[#2196f3] rounded-md px-3 py-2 flex items-center justify-start text-white cursor-pointer space-x-2 w-fit font-medium'>
                                  <span>
                                    {
                                      (surveyLanguageCode !== '') ?
                                        (question && question.transl && question.transl[surveyLanguageCode] && question.transl[surveyLanguageCode].optionsList && question.transl[surveyLanguageCode].optionsList[option.id]) ?
                                          question.transl[surveyLanguageCode].optionsList[option.id] : option.name
                                        : option.name
                                    }
                                  </span>
                                  <svg xmlns="http://www.w3.org/2000/svg" width="22" height="22" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="icon icon-tabler icons-tabler-outline icon-tabler-check"><path stroke="none" d="M0 0h24v24H0z" fill="none" /><path d="M5 12l5 5l10 -10" /></svg>
                                </div>

                                :
                                <div onClick={() => handleDMGRadio(question, row, option)} className='bg-[#2196f3]/10 rounded-md p-2 px-3 cursor-pointer flex items-center justify-center text-[#212121]/80 space-x-2 w-fit font-medium'>
                                  <span>
                                    {
                                      (surveyLanguageCode !== '') ?
                                        (question && question.transl && question.transl[surveyLanguageCode] && question.transl[surveyLanguageCode].optionsList && question.transl[surveyLanguageCode].optionsList[option.id]) ?
                                          question.transl[surveyLanguageCode].optionsList[option.id] : option.name
                                        : option.name
                                    }
                                  </span>
                                  {/* <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="icon icon-tabler icons-tabler-outline icon-tabler-circle"><path stroke="none" d="M0 0h24v24H0z" fill="none" /><path d="M12 12m-9 0a9 9 0 1 0 18 0a9 9 0 1 0 -18 0" /></svg> */}
                                </div>
                              }

                            </div>
                          ) : null}
                      </div>
                    </div>
                  ) : null}


              </div>



            </div>

            : null}

        </div>



      </div>



    </>
  );
}